import { ManagerHome } from '../../manager/components/home';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(ManagerHome);

export const roles: string[] = [];
export const path = '/manager';
export const element = <AnimatedPage />